// extracted by mini-css-extract-plugin
export const callout = "hero-module--callout--dcb6d";
export const calloutInner = "hero-module--calloutInner--1I-of";
export const calloutHeader = "hero-module--calloutHeader--r3vwB";